import * as Types from '../graphQlTypes.generated';

import { graphQlService } from '@doxyme/frontend/services/graphql.service';
export type CreateFileTransferSessionMutationVariables = Types.Exact<{
  input: Types.FileTransferSessionInput;
}>;


export type CreateFileTransferSessionMutation = { __typename?: 'Mutation', FileTransfer: { __typename?: 'FileTransferMutations', createFileTransferSession: string } };

export type RequestFileTransferUploadMutationVariables = Types.Exact<{
  input: Types.RequestUploadUrlInput;
}>;


export type RequestFileTransferUploadMutation = { __typename?: 'Mutation', FileTransfer: { __typename?: 'FileTransferMutations', requestFileTransferUpload: { __typename?: 'RequestUploadUrlResponseDto', uuid: string, uploadLink: string } } };

export type FileTransferDeleteFileMutationVariables = Types.Exact<{
  input: Types.FileTransferDeleteInput;
}>;


export type FileTransferDeleteFileMutation = { __typename?: 'Mutation', FileTransfer: { __typename?: 'FileTransferMutations', fileTransferDeleteFile: string } };


export const CreateFileTransferSessionDocument = `
    mutation createFileTransferSession($input: FileTransferSessionInput!) {
  FileTransfer {
    createFileTransferSession(createFileTransferSessionInput: $input)
  }
}
    `;
export const RequestFileTransferUploadDocument = `
    mutation requestFileTransferUpload($input: RequestUploadUrlInput!) {
  FileTransfer {
    requestFileTransferUpload(requestUploadUrlInput: $input) {
      uuid
      uploadLink
    }
  }
}
    `;
export const FileTransferDeleteFileDocument = `
    mutation fileTransferDeleteFile($input: FileTransferDeleteInput!) {
  FileTransfer {
    fileTransferDeleteFile(fileTransferDeleteInput: $input)
  }
}
    `;

const injectedRtkApi = graphQlService.injectEndpoints({
  endpoints: (build) => ({
    createFileTransferSession: build.mutation<CreateFileTransferSessionMutation, CreateFileTransferSessionMutationVariables>({
      query: (variables) => ({ document: CreateFileTransferSessionDocument, variables })
    }),
    requestFileTransferUpload: build.mutation<RequestFileTransferUploadMutation, RequestFileTransferUploadMutationVariables>({
      query: (variables) => ({ document: RequestFileTransferUploadDocument, variables })
    }),
    fileTransferDeleteFile: build.mutation<FileTransferDeleteFileMutation, FileTransferDeleteFileMutationVariables>({
      query: (variables) => ({ document: FileTransferDeleteFileDocument, variables })
    }),
  }),
});

export { injectedRtkApi as api };
export const { useCreateFileTransferSessionMutation, useRequestFileTransferUploadMutation, useFileTransferDeleteFileMutation } = injectedRtkApi;

